import React, { Component } from 'react'
import g from 'glamorous'

class TeamInDate extends Component { 
    render () {
        const { team, className, gotomatch } = this.props
        return (<g.Div className={['team-info', className].join(' ')}>
                    <g.Img src={require(`./images/flags/${team.flag}`)} className="flag-team" />
                    <g.Span className="name-team-short only-desktop">{team.isoalph3}</g.Span>
                </g.Div>)
    }
}

export default TeamInDate


// WEBPACK FOOTER //
// ./src/components/calendar/team-in-date-fragm.js